// src/utils/driveUtils.js

export const isImageUrl = (value) => {
  if (!value) return false;

  const str = String(value).toLowerCase().trim();

  return (
    str.startsWith('http://') ||
    str.startsWith('https://') ||
    str.startsWith('data:image/')
  );
};

export const extractGoogleDriveFileId = (url) => {
  if (!url) return null;

  const str = String(url).trim();

  const shareMatch = str.match(/\/file\/d\/([a-zA-Z0-9-_]+)/);
  if (shareMatch) return shareMatch[1];

  const idMatch = str.match(/[?&]id=([a-zA-Z0-9-_]+)/);
  if (idMatch) return idMatch[1];

  const docMatch = str.match(/\/d\/([a-zA-Z0-9-_]+)/);
  if (docMatch) return docMatch[1];

  const genericMatch = str.match(/([a-zA-Z0-9-_]{25,})/);
  if (genericMatch) return genericMatch[1];

  return null;
};

export const getGoogleDriveViewUrl = (url) => {
  const fileId = extractGoogleDriveFileId(url);
  if (fileId) {
    return `https://drive.google.com/file/d/${fileId}/view`;
  }
  return url;
};

export const getDriveThumbnailUrl = (url, size = 'w400') => {
  const fileId = extractGoogleDriveFileId(url);
  return fileId ? `https://drive.google.com/thumbnail?id=${fileId}&sz=${size}` : '';
};
